import React from "react";
import { Box } from "@chakra-ui/react";

export const TechnologyBackground: React.FC = () => {
  return (
    <Box
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      overflow="hidden"
      zIndex="0"
      pointerEvents="none"
    >
      {/* Deep blue tech gradient */}
      <Box
        position="absolute"
        width="100%"
        height="100%"
        background="linear-gradient(135deg, #0a1628 0%, #102040 25%, #1a3050 50%, #102040 75%, #0a1628 100%)"
      />

      {/* Technology SVG */}
      <svg
        className="tech-svg"
        viewBox="0 0 1440 900"
        preserveAspectRatio="xMidYMid slice"
        style={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      >
        <defs>
          {/* Bronze/gold gradient */}
          <linearGradient id="bronzeGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#cd9b4a" stopOpacity="1" />
            <stop offset="50%" stopColor="#d4a855" stopOpacity="1" />
            <stop offset="100%" stopColor="#b8863f" stopOpacity="1" />
          </linearGradient>
          <linearGradient id="goldGrad" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#ffd700" stopOpacity="0.9" />
            <stop offset="50%" stopColor="#ffec80" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#daa520" stopOpacity="0.9" />
          </linearGradient>
          <linearGradient id="darkBronze" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#8b6914" stopOpacity="1" />
            <stop offset="100%" stopColor="#6b5210" stopOpacity="1" />
          </linearGradient>

          {/* Gear tooth pattern for reuse */}
          <pattern id="gridPattern" width="40" height="40" patternUnits="userSpaceOnUse">
            <path d="M0,20 L40,20 M20,0 L20,40" stroke="#1a4060" strokeWidth="0.5" opacity="0.3" />
          </pattern>
        </defs>

        {/* Subtle grid background */}
        <rect width="100%" height="100%" fill="url(#gridPattern)" />

        {/* Large background gears */}
        <g className="gears-back">
          {/* Gear 1 - top left */}
          <g transform="translate(120, 150)">
            <g className="gear-1">
              <circle cx="0" cy="0" r="80" fill="none" stroke="url(#darkBronze)" strokeWidth="20" />
              <circle cx="0" cy="0" r="30" fill="url(#darkBronze)" />
              <circle cx="0" cy="0" r="15" fill="#0a1628" />
              {[...Array(12)].map((_, i) => (
                <rect key={i} x="-8" y="-100" width="16" height="25" fill="url(#darkBronze)" transform={`rotate(${i * 30})`} />
              ))}
            </g>
          </g>

          {/* Gear 2 - top right */}
          <g transform="translate(1320, 180)">
            <g className="gear-2">
              <circle cx="0" cy="0" r="100" fill="none" stroke="url(#darkBronze)" strokeWidth="25" />
              <circle cx="0" cy="0" r="40" fill="url(#darkBronze)" />
              <circle cx="0" cy="0" r="20" fill="#0a1628" />
              {[...Array(16)].map((_, i) => (
                <rect key={i} x="-10" y="-125" width="20" height="30" fill="url(#darkBronze)" transform={`rotate(${i * 22.5})`} />
              ))}
            </g>
          </g>

          {/* Gear 3 - bottom left */}
          <g transform="translate(80, 750)">
            <g className="gear-3">
              <circle cx="0" cy="0" r="90" fill="none" stroke="url(#darkBronze)" strokeWidth="22" />
              <circle cx="0" cy="0" r="35" fill="url(#darkBronze)" />
              <circle cx="0" cy="0" r="18" fill="#0a1628" />
              {[...Array(14)].map((_, i) => (
                <rect key={i} x="-9" y="-112" width="18" height="28" fill="url(#darkBronze)" transform={`rotate(${i * 25.7})`} />
              ))}
            </g>
          </g>

          {/* Gear 4 - bottom right */}
          <g transform="translate(1380, 780)">
            <g className="gear-4">
              <circle cx="0" cy="0" r="70" fill="none" stroke="url(#darkBronze)" strokeWidth="18" />
              <circle cx="0" cy="0" r="28" fill="url(#darkBronze)" />
              <circle cx="0" cy="0" r="14" fill="#0a1628" />
              {[...Array(10)].map((_, i) => (
                <rect key={i} x="-7" y="-88" width="14" height="22" fill="url(#darkBronze)" transform={`rotate(${i * 36})`} />
              ))}
            </g>
          </g>
        </g>

        {/* Mid-layer bronze gears */}
        <g className="gears-mid">
          {/* Gear 5 - left side */}
          <g transform="translate(200, 450)">
            <g className="gear-5">
              <circle cx="0" cy="0" r="60" fill="none" stroke="url(#bronzeGrad)" strokeWidth="15" />
              <circle cx="0" cy="0" r="22" fill="url(#bronzeGrad)" />
              <circle cx="0" cy="0" r="10" fill="#102040" />
              {[...Array(10)].map((_, i) => (
                <rect key={i} x="-6" y="-75" width="12" height="20" fill="url(#bronzeGrad)" transform={`rotate(${i * 36})`} />
              ))}
            </g>
          </g>

          {/* Gear 6 - right side */}
          <g transform="translate(1250, 500)">
            <g className="gear-6">
              <circle cx="0" cy="0" r="55" fill="none" stroke="url(#bronzeGrad)" strokeWidth="14" />
              <circle cx="0" cy="0" r="20" fill="url(#bronzeGrad)" />
              <circle cx="0" cy="0" r="9" fill="#102040" />
              {[...Array(8)].map((_, i) => (
                <rect key={i} x="-6" y="-69" width="12" height="18" fill="url(#bronzeGrad)" transform={`rotate(${i * 45})`} />
              ))}
            </g>
          </g>

          {/* Gear 7 - center top */}
          <g transform="translate(720, 200)">
            <g className="gear-7">
              <circle cx="0" cy="0" r="50" fill="none" stroke="url(#bronzeGrad)" strokeWidth="12" />
              <circle cx="0" cy="0" r="18" fill="url(#bronzeGrad)" />
              <circle cx="0" cy="0" r="8" fill="#102040" />
              {[...Array(8)].map((_, i) => (
                <rect key={i} x="-5" y="-62" width="10" height="16" fill="url(#bronzeGrad)" transform={`rotate(${i * 45})`} />
              ))}
            </g>
          </g>

          {/* Gear 8 - center bottom */}
          <g transform="translate(700, 820)">
            <g className="gear-8">
              <circle cx="0" cy="0" r="45" fill="none" stroke="url(#bronzeGrad)" strokeWidth="11" />
              <circle cx="0" cy="0" r="16" fill="url(#bronzeGrad)" />
              <circle cx="0" cy="0" r="7" fill="#102040" />
              {[...Array(9)].map((_, i) => (
                <rect key={i} x="-5" y="-56" width="10" height="14" fill="url(#bronzeGrad)" transform={`rotate(${i * 40})`} />
              ))}
            </g>
          </g>
        </g>

        {/* Small accent gears - gold */}
        <g className="gears-small">
          <g transform="translate(350, 200)">
            <g className="gear-small-1">
              <circle cx="0" cy="0" r="25" fill="none" stroke="url(#goldGrad)" strokeWidth="6" />
              <circle cx="0" cy="0" r="8" fill="url(#goldGrad)" />
              {[...Array(6)].map((_, i) => (
                <rect key={i} x="-3" y="-31" width="6" height="8" fill="url(#goldGrad)" transform={`rotate(${i * 60})`} />
              ))}
            </g>
          </g>
          <g transform="translate(1100, 250)">
            <g className="gear-small-2">
              <circle cx="0" cy="0" r="30" fill="none" stroke="url(#goldGrad)" strokeWidth="7" />
              <circle cx="0" cy="0" r="10" fill="url(#goldGrad)" />
              {[...Array(8)].map((_, i) => (
                <rect key={i} x="-4" y="-37" width="8" height="10" fill="url(#goldGrad)" transform={`rotate(${i * 45})`} />
              ))}
            </g>
          </g>
          <g transform="translate(400, 700)">
            <g className="gear-small-3">
              <circle cx="0" cy="0" r="28" fill="none" stroke="url(#goldGrad)" strokeWidth="6" />
              <circle cx="0" cy="0" r="9" fill="url(#goldGrad)" />
              {[...Array(7)].map((_, i) => (
                <rect key={i} x="-3" y="-34" width="6" height="9" fill="url(#goldGrad)" transform={`rotate(${i * 51.4})`} />
              ))}
            </g>
          </g>
          <g transform="translate(1050, 680)">
            <g className="gear-small-4">
              <circle cx="0" cy="0" r="22" fill="none" stroke="url(#goldGrad)" strokeWidth="5" />
              <circle cx="0" cy="0" r="7" fill="url(#goldGrad)" />
              {[...Array(6)].map((_, i) => (
                <rect key={i} x="-3" y="-27" width="6" height="7" fill="url(#goldGrad)" transform={`rotate(${i * 60})`} />
              ))}
            </g>
          </g>
        </g>

        {/* Connecting rods/pipes */}
        <g className="pipes">
          <line x1="200" y1="150" x2="350" y2="200" stroke="url(#bronzeGrad)" strokeWidth="8" strokeLinecap="round" />
          <line x1="720" y1="250" x2="720" y2="400" stroke="url(#bronzeGrad)" strokeWidth="6" strokeLinecap="round" />
          <line x1="1100" y1="250" x2="1250" y2="500" stroke="url(#bronzeGrad)" strokeWidth="7" strokeLinecap="round" />
          <line x1="200" y1="510" x2="200" y2="660" stroke="url(#bronzeGrad)" strokeWidth="6" strokeLinecap="round" />
          <line x1="400" y1="728" x2="620" y2="820" stroke="url(#bronzeGrad)" strokeWidth="6" strokeLinecap="round" />
          <line x1="780" y1="820" x2="1050" y2="680" stroke="url(#bronzeGrad)" strokeWidth="5" strokeLinecap="round" />
        </g>

        {/* Circuit traces */}
        <g className="circuits" opacity="0.4">
          <path d="M0,400 L100,400 L100,350 L200,350" stroke="#4080a0" strokeWidth="2" fill="none" />
          <path d="M0,500 L150,500 L150,450 L300,450" stroke="#4080a0" strokeWidth="2" fill="none" />
          <path d="M1440,350 L1300,350 L1300,400 L1200,400" stroke="#4080a0" strokeWidth="2" fill="none" />
          <path d="M1440,600 L1350,600 L1350,550 L1250,550" stroke="#4080a0" strokeWidth="2" fill="none" />
          <path d="M500,0 L500,80 L550,80 L550,150" stroke="#4080a0" strokeWidth="2" fill="none" />
          <path d="M900,0 L900,100 L850,100 L850,180" stroke="#4080a0" strokeWidth="2" fill="none" />
          <path d="M600,900 L600,800 L650,800 L650,750" stroke="#4080a0" strokeWidth="2" fill="none" />
          <path d="M850,900 L850,820 L800,820 L800,760" stroke="#4080a0" strokeWidth="2" fill="none" />
        </g>

        {/* Small indicator lights */}
        <g className="indicator-lights">
          <circle cx="100" cy="350" r="4" fill="#00ff88" className="light-1" />
          <circle cx="300" cy="450" r="4" fill="#00ff88" className="light-2" />
          <circle cx="1200" cy="400" r="4" fill="#ff8800" className="light-3" />
          <circle cx="1250" cy="550" r="4" fill="#00ff88" className="light-4" />
          <circle cx="550" cy="150" r="4" fill="#ff8800" className="light-5" />
          <circle cx="850" cy="180" r="4" fill="#00ff88" className="light-6" />
          <circle cx="650" cy="750" r="4" fill="#ff8800" className="light-7" />
          <circle cx="800" cy="760" r="4" fill="#00ff88" className="light-8" />
        </g>
      </svg>

      {/* Floating tech particles */}
      <Box className="tech-particles" position="absolute" width="100%" height="100%" top="0" left="0">
        {[...Array(10)].map((_, i) => (
          <Box
            key={i}
            className={`tech-particle tech-particle-${i + 1}`}
            position="absolute"
            width="4px"
            height="4px"
            borderRadius="50%"
            backgroundColor={i % 2 === 0 ? "#ffd700" : "#00ff88"}
            boxShadow={`0 0 6px ${i % 2 === 0 ? "#ffd700" : "#00ff88"}`}
            opacity="0"
          />
        ))}
      </Box>
    </Box>
  );
};

export default TechnologyBackground;
